export const EMAIL_SOURCE_FETCH_REQUESTED =
  'emailSource/emailSourceFetchRequested';

export const emailSourceFetchRequested = (emailSourceId, callback) => ({
  type: EMAIL_SOURCE_FETCH_REQUESTED,
  payload: { emailSourceId, callback: (json) => callback(json) }
});
